import React from "react";
import DialogBox from "../DialogBox";
import { locale } from "../../utils/LocaleManager";
import { useContentStore } from "../../stores/contentStore";
import TreeView from "../TreeView";
import { Box, Card, CardContent, Container, Grid, Stack } from "@mui/material";
import { moveVideos } from "../../models/video";
import { moveVideoToFolder } from "../../services/folderServices";
import { Bounce, toast } from "react-toastify";
import { useFolderStore } from "../../stores/folderStore";

const MoveVideo = () => {
  const {
    setIsShowMoveDialog,
    selectedThumbnails,
    setSelectedThumbnails,
    setIsLoading,
  } = useContentStore((state: any) => ({
    setIsShowMoveDialog: state.setIsShowMoveDialog,
    selectedThumbnails: state.selectedThumbnails,
    setSelectedThumbnails: state.setSelectedThumbnails,
    setIsLoading: state.setIsLoading,
  }));

  const { setIsMoveSuccess, folderId, folderName, previousFolderName } =
    useFolderStore((state: any) => ({
      setIsMoveSuccess: state.setIsMoveSuccess,
      folderId: state.folderId,
      folderName: state.folderName,
      previousFolderName: state.previousFolderName,
    }));

  const fetchMoveVideo = async (id: string, request: moveVideos) => {
    try {
      setIsLoading(true);
      const response = await moveVideoToFolder(id, request);
      if (response?.status === 200) {
        setIsMoveSuccess(true);
        setIsShowMoveDialog(false);
        setSelectedThumbnails([]);
        toast.success(
          selectedThumbnails.length === 1
            ? `Move "${selectedThumbnails[0].name}" to "${folderName}"`
            : `${selectedThumbnails.length} videos have been moved from "${previousFolderName}" to "${folderName}"`,
          {
            position: "bottom-left",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            pauseOnFocusLoss: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
            onClose: async () => {
              setIsMoveSuccess(false);
            },
          },
        );
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error moving videos:", error);
    }
  };

  const moveVideos = async () => {
    const requestBody = {
      videoIndexIds: selectedThumbnails.map((thumb: any) => thumb.videoIndexId),
    };
    const id = folderId === 1 ? null : folderId;
    await fetchMoveVideo(id, requestBody);
  };

  const renderMoveDialog = () => (
    <Container>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              width: "100%",
              height: "25rem",
              border: "0.06rem solid #8A8E94",
              borderRadius: "0.5rem",
              overflow: "auto",
            }}
          >
            <Stack>
              {selectedThumbnails.map((thumbnail: any) => (
                <Card variant="outlined" key={thumbnail.videoIndexId}>
                  <CardContent style={{ padding: "1.25rem" }}>
                    <Stack direction="row" gap="0.625rem">
                      <img
                        src={thumbnail.image}
                        style={{
                          height: "auto",
                          width: "2.5rem",
                          borderRadius: "0.25rem",
                          alignSelf: "stretch",
                        }}
                        alt={thumbnail.name}
                      />
                      {thumbnail.name}
                    </Stack>
                  </CardContent>
                </Card>
              ))}
            </Stack>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              width: "100%",
              height: "25rem",
              border: "0.06rem solid #8A8E94",
              borderRadius: "0.5rem",
              overflow: "auto",
              padding: "0.5rem",
            }}
          >
            <TreeView />
          </Box>
        </Grid>
      </Grid>
    </Container>
  );

  return (
    <DialogBox
      header={
        selectedThumbnails.length === 1
          ? `Move "${selectedThumbnails[0].name}" to "${folderName}"`
          : `Move ${selectedThumbnails.length} videos from "${previousFolderName}" to "${folderName}" folder`
      }
      body={<></>}
      subBody={renderMoveDialog()}
      onCancel={() => setIsShowMoveDialog(false)}
      onSubmit={moveVideos}
      isDelete={false}
      primaryButton={locale.control_move}
      secondaryButton={locale.cancel}
      width={"62.5rem"}
    />
  );
};

export default MoveVideo;
